import  '../../css/style.css';
import React from 'react'
import MyTable from '../../components/myTable';
import { useSelector } from 'react-redux';


const FailedTransaction = () => {

  const marginLeft = useSelector(state => state.style.payload.marginLeft)
  return (
    <div className=''
    >
        <MyTable page={"Failed Transactions"}/>
      
    </div>
  )
}

export default FailedTransaction
